<template>
  <button class="button +green" @click="sharePage" data-gtm-action="share page">Share Page</button>
</template>

<script setup lang="ts">
const sharePage = async () => {
  if (navigator?.share) {
    try {
      await navigator.share({
        title: 'Nutritious, Delicious, Convenient Oatmeal Bre...',
        url: window.location.href
      })
    } catch (error) {
      console.error('Error sharing:', error)
    }
  } else {
    console.error('Navigator can\'t share')
  }
}
</script>